<template>
  <nav
    role="navigation"
    class="c-desktop-nav"
  >
    <template v-for="(navItem, index) in mainNav">
      <nav-item
        :key="'c-desktop-nav__item_' + index"
        :ref="'j-desktop-nav__item_' + index"
        :item="navItem"
        :is-mobile="isMobile"
        :my-index="index"
        :tabindex-start="mainNav.length+1"
        class="c-desktop-nav__item"
        :class="{'c-desktop-nav__item--no-margin':index === mainNav.length-1}"
      />
    </template>
    <div class="c-desktop-nav__active-indicator j-desktop-nav__active-position" />
  </nav>
</template>

<script>
import NavItem from "./NavItem";
export default {
  name: "DesktopNav",
  components:{NavItem},
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    openId: {
      type: Number,
      default: null
    },
    mainNav: {
      type: Array,
      default: null
    },
  },
  data(){
    return {
      indicatorElement: null
    }
  },
  mounted(){
    this.$nextTick(() => {
      if(this.openId !== null){
        if(this.$refs["j-desktop-nav__item_" + this.openId]){
          this.$refs["j-desktop-nav__item_" + this.openId][0].showSubMenu();
        }
      }
      try{
        this.indicatorElement = this.$el.getElementsByClassName("j-desktop-nav__active-position")[0];
      } catch (e){
        this.indicatorElement = null;
      }
      this.positionIndicator();
    });
  },
  methods: {
    closeOtherMenus(notThisId = null){
      this.$parent.closeOtherMenus(notThisId);
      for(let i = 0; i < this.mainNav.length;++i){
        if(i !== notThisId){
          if(this.$refs["j-desktop-nav__item_" + i]){
            this.$refs["j-desktop-nav__item_" + i][0].hideSubMenu();
          }
        }
      }
      this.positionIndicator();
    },
    clearOpen(id){
      this.$parent.clearOpen(id);
      this.positionIndicator();
    },
    positionIndicator(){
      this.$nextTick(() => {
        if(!this.indicatorElement){
          return;
        }
        if(this.openId === null){
          this.indicatorElement.style.width = 0;
          this.indicatorElement.style.left = 0;
          return;
        }
        let currentRef = this.$refs["j-desktop-nav__item_" + this.openId] ?
          this.$refs["j-desktop-nav__item_" + this.openId][0]:null;

        if(currentRef){
          let pos = currentRef.$el.getBoundingClientRect();
          this.indicatorElement.style.width = pos.width + "px";
          //adjust for padding
          this.indicatorElement.style.left = currentRef.$el.offsetLeft + "px";
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-desktop-nav{
    position: relative;
    &__active-indicator{
      @include themify($themes){
        background-color: themed("background", "dark");
      }
      position: absolute;
      bottom: - rem(39px);
      height: rem(3px);
      width: 0;
      transition: 0.5s;
      z-index: $zindex-global-header;
    }
    &__item{
      display: inline-block;
      margin-right: rem(30px);

      &--no-margin{
        margin-right: 0;
      }
    }

    &__featured{

      &-item{
        list-style: none;
        display: inline;
        position: relative;
        margin-right: rem(30px);
        &-link{
          @include themify($themes) {
            color: themed("primary", "base");
          }
          text-decoration: none;
          position: relative;
          &:after{
            content: "";
            height: 22px;
            width: 100%;
            @include themify($themes) {
              background: linear-gradient(180deg,transparent 70%,themed("accent") 0);
            }
            position: absolute;
            bottom: 0;
            left: 0;
            opacity: 1;
            z-index: -1;
          }
        }
      }

    }
  }
</style>